<template lang="pug">
  v-dialog(v-model="show" persistent max-width="1000px" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable)
    v-snackbar( v-model="snackbar" :color="snackbarColor" ) {{ snackbarMessage }}
      template( v-slot:action="{attrs}")
        v-btn(text v-bind="attrs"
          @click="snackbar = false") {{ $t('buttons.closeButtonLabel') }}
    AddNewMessageTemplateDialog(
      v-if="showAddNewMessageTemplateDialog"
      :show="showAddNewMessageTemplateDialog"
      @close="onAddNewTemplateDialogClose"
      @templateName="onAddNewTemplateDialogClose")
    ControlDeleteMessageDialog(
      v-if="showControlDeleteMessageDialog"
      :showDialog="showControlDeleteMessageDialog"
      :selectedItemValue="selectedItemValue"
      @delete="onDeleteTemplateClick"
      @close="onDeleteMessageDialogCloseClick"
    )
    v-form(v-model="isFormValid" ref="form" @submit.prevent="onSubmitButtonClick")
      v-card.d-flex.flex-column
        v-card-title {{ $t('sendEmailDialog.dialogTitle') }}
        v-card-text
          v-row.ma-0.mt-0
            v-col(cols="12" xl="6" lg="6" md="6" sm="12")
              v-row.ma-0.mb-0.mr-3
                v-col.pb-0(cols="9" xl="9" lg="9" md="9" sm="9")
                  v-select(
                    append-icon="fas fa-chevron-down"
                    outlined
                    :label="$t('sendEmailDialog.templateLabel')"
                    v-model="selectedItemValue"
                    @change="selectedItem"
                    :items="templateList"
                    item-text="name"
                    item-value="id"
                    :loading="isTemplateList"
                    return-object
                    :no-data-text="$t('sendEmailDialog.noData')"
                  )
                v-col.pb-8.pr-0.text-end(v-if="this.$vuetify.breakpoint.smAndUp" cols="3" align-self="center" )
                  v-btn.align-self-end(x-large @click="onDeleteTemplate" height="56" :disabled="saveInProgress || !selectedItemValue || !isFormValid" outlined)
                    v-icon fas fa-trash
                v-col.pb-8.text-end.px-0(v-else cols="3" align-self="center" )
                  v-btn.align-self-end(medium @click="onDeleteTemplate" height="56" :disabled="saveInProgress || !selectedItemValue || !isFormValid" outlined)
                    v-icon fas fa-trash
              v-row.ma-0.mt-0
                v-col.pb-0.pt-0(cols="12")
                  v-text-field.pb-0(
                    outlined
                    :label="$t('sendEmailDialog.subjectMessage')"
                    :rules="subjectRules"
                    v-model="subject")
              v-row.ma-0.mt-0
                v-col.pb-0.pt-0(cols="12")
                  v-text-field.pb-0(
                      dense
                      outlined
                      :label="$t('sendEmailDialog.replyToAddressFieldLabel')"
                      :rules="replyToRules"
                      v-model="replyToAddress")
              v-row.ma-0
                v-col.pb-0.pt-0(cols="12")
                  v-textarea(
                    v-model="text"
                    rows="6"
                    outlined
                    :label="$t('sendEmailDialog.textLabel')"
                    :rules="textRules")
              v-row.ma-0.mb-0
                v-col.pt-0.text-start(cols="6")
                  v-btn( small @click="onAddNewTemplateClick" :disabled="saveInProgress || !isFormValid") {{ $t('sendEmailDialog.addNewTemplateLabel') }}
                v-col.text-end.pt-0(cols="6")
                  v-btn(small color="primary" @click="onUpdateTemplateClick(selectedItemValue)" :disabled="saveInProgress || !isFormValid || !selectedItemValue" :loading="isFetchInProgress") {{ $t('sendEmailDialog.saveNewTemplate') }}
            v-col.pt-6(cols="12" xl="6" lg="6" md="6" sm="12")
              v-card.elevation-0
                v-card-title.pb-0 {{ $t('sendEmailDialog.boarders') }}
                v-card-text.overflow-auto(v-if="this.$vuetify.breakpoint.mdAndUp" style="height: 50vh;")
                  v-list.pt-0
                    v-list-item.pl-0(two-line v-for="(item, idx) in currentBoarderList" :key="idx")
                      v-icon.pr-2( medium color="red" v-if="item.boarder.person.emails.length < 1") far fa-exclamation-circle
                      v-icon.pr-2(v-else  medium color="green") far fa-check-circle
                      v-list-item-content.pb-0
                        v-list-item-title.pl-1 {{ item.boarder.person.firstName }} {{ item.boarder.person.familyName }}
                        v-list-item-subtitle.pt-0.pl-1 {{item.boarder.customer.name}}
                        v-list-item-subtitle.pt-0.pl-1 {{item.boarder.boarderGroupCollection[0].name}}
                        v-list-item-subtitle.pt-0.pl-1(v-if="item.boarder.person.emails.length > 0" v-for="(i,idx) in item.boarder.person.emails" :key="idx") {{ i.email }}
                        v-list-item-subtitle.pl-1(v-if="item.boarder.person.emails.length < 1") {{ $t('sendEmailDialog.existingEmailLabel') }}
                v-card-text(v-else)
                  v-list.pt-0
                    v-list-item.pl-0(two-line v-for="(item, idx) in currentBoarderList" :key="idx")
                      v-icon.pr-2( medium color="red" v-if="item.boarder.person.emails.length < 1") far fa-exclamation-circle
                      v-icon.pr-2(v-else  medium color="green") far fa-check-circle
                      v-list-item-content.pb-0
                        v-list-item-title.pl-1 {{ item.boarder.person.firstName }} {{ item.boarder.person.familyName }}
                        v-list-item-subtitle.pt-0.pl-1 {{item.boarder.customer.name}}
                        v-list-item-subtitle.pt-0.pl-1 {{item.boarder.boarderGroupCollection[0].name}}
                        v-list-item-subtitle.pt-0.pl-1(v-if="item.boarder.person.emails.length > 0" v-for="(i,idx) in item.boarder.person.emails" :key="idx") {{ i.email }}
                        v-list-item-subtitle.pl-1(v-if="item.boarder.person.emails.length < 1") {{ $t('sendEmailDialog.existingEmailLabel') }}

        v-divider
        v-card-actions
          v-spacer
          v-btn(color="primary" text :disabled="saveInProgress" :loading="isSaveInProgress" @click="onCloseButtonClick") {{ $t('addBoarderDialog.closeButtonLabel') }}
          v-btn.mr-4( color="primary" type="submit" :disabled="saveInProgress || !isFormValid" :loading="saveInProgress") {{ $t('sendEmailDialog.sendMessage') }}


</template>

<script lang="ts">
import Vue from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'
import AddNewMessageTemplateDialog from "@/components/boarder-management/AddNewMessageTemplateDialog.vue";
import {BoarderResponse, MessageTemplateListResponse} from "@/types/service-response";
import {BoarderSelectableListItem} from "@/types";
import _ from "lodash";
import i18n, {TranslateResult} from "@/i18n";
import {Action} from "vuex-class";
import {
  DELETE_MESSAGE_TEMPLATE,
  FETCH_MESSAGE_TEMPLATE_LIST,
  SAVE_NEW_MESSAGE_TEMPLATE, SEND_NEW_MESSAGE, UPDATE_MESSAGE_TEMPLATE,
} from "@/store/action-types";
import {CreateNewMessageTemplatePayload, MessagePayload, UpdateMessageTemplatePayload} from "@/types/payload";
import {MessageTemplateList} from "@/model/MessageTemplateList";
import ControlDeleteMessageDialog from "@/components/boarder-management/ControlDeleteMessageDialog.vue";
import {REPLY_TO_ADDRESS_KEY} from "@/constants";

function validateEmail (v: string): boolean | TranslateResult {
  if (v) {
    return /.+@.+\..+/.test(v) || i18n.t('validation.emailMustBeValid')
  }
  return true
}

@Component({
  components: {
    AddNewMessageTemplateDialog,
    ControlDeleteMessageDialog
  }
})
export default class SendEmailDialog extends Vue {

  $refs!: {
    form: Vue & {
      validate(): boolean,
      resetValidation(): boolean
    }
  }

  @Prop({ type: Boolean, default: false }) readonly show!: boolean
  @Prop({type: Array, required: true}) readonly boarderList!: BoarderResponse[]
  @Action(FETCH_MESSAGE_TEMPLATE_LIST) fetchTemplateList!: {(): Promise<MessageTemplateList[]> }
  @Action(SAVE_NEW_MESSAGE_TEMPLATE) saveNewTemplate!: { (payload: CreateNewMessageTemplatePayload): Promise<MessageTemplateList> }
  @Action(DELETE_MESSAGE_TEMPLATE) deleteMessageTemplate!: { (payload: string): Promise<void> }
  @Action(UPDATE_MESSAGE_TEMPLATE) updateMessageTemplate!: { (payload: UpdateMessageTemplatePayload): Promise<void> }
  @Action(SEND_NEW_MESSAGE) sendNewMessage!: { (payload: MessagePayload): Promise<void> }


  private snackbar: boolean = false
  private snackbarMessage: string = ''
  private snackbarColor: string = ''
  private errorSnackbar: boolean = false
  private showAddNewMessageTemplateDialog: boolean = false
  private currentBoarderList: BoarderSelectableListItem[] = []
  private saveInProgress: boolean = false
  private isSaveInProgress: boolean = false
  private text: string = ''
  private subject: string = ''
  private replyToAddress: string = ''
  private templateList: MessageTemplateList[] = []
  private textRules:  Array<(v: string) => string | boolean> = [
    (v: string) => !!v || i18n.t('validation.valueIsRequired').toString(),
  ]
  private subjectRules:  Array<(v: string) => string | boolean> = [
    (v: string) => !!v || i18n.t('validation.valueIsRequired').toString(),
  ]
  private replyToRules:  Array<(v: string) => TranslateResult | boolean> = [
    (v: string) => validateEmail(v),
  ]
  private selectedItemValue: MessageTemplateList | null = null
  private isFormValid: boolean = false
  private newTemplateName: string = ''
  private isFetchInProgress: boolean = false
  private isTemplateList: boolean = false
  private showControlDeleteMessageDialog: boolean = false

  @Watch('replyToAddress')
  watchReplyToAddress(newVal: string): void {
    if (newVal) {
        localStorage.setItem(REPLY_TO_ADDRESS_KEY, newVal)
    } else {
      localStorage.removeItem(REPLY_TO_ADDRESS_KEY)
    }
  }

  onCloseButtonClick (): void {
    this.$emit('close')
  }

  onAddNewTemplateClick (): void {
    if(this.isFormValid ) {
      this.showAddNewMessageTemplateDialog = true
    }
  }

  onAddNewTemplateDialogClose (item: string): void {
    this.newTemplateName = item
    this.showAddNewMessageTemplateDialog = false
    this.onSaveNewTemplateClick()
  }

  selectedItem(item: MessageTemplateList) {
    if(item) {
      this.text = item.text
      this.subject = item.subject
    }
  }

  onDeleteTemplate () {
    this.showControlDeleteMessageDialog = true
  }

  onDeleteMessageDialogCloseClick () {
    this.showControlDeleteMessageDialog = false
  }

  async onSubmitButtonClick (): Promise<void> {
    const personsList: string[] = this.currentBoarderList.filter((i: BoarderSelectableListItem) => i.boarder.person.emails.length > 0).map((item: BoarderSelectableListItem) => {
      return `/api/person/${item.boarder.person.id}`
    })
    const payload: MessagePayload = {
      addressees: personsList,
      subject: this.subject,
      text: this.text,
      replyToAddress: this.replyToAddress.trim().length > 0 ? this.replyToAddress.trim() : null
    }
    try {
      this.saveInProgress = true
      await this.sendNewMessage(payload)
      this.saveInProgress = false
      this.$emit('send')
      this.snackbar = true
      this.snackbarMessage = this.$t('sendEmailDialog.messageSend').toString()
      this.snackbarColor = 'success'
    }catch (e) {
      this.snackbar = true
      this.snackbarMessage = this.$t('sendEmailDialog.messageSendFalse').toString()
      this.snackbarColor = 'error'
    }
  }

   async onSaveNewTemplateClick (): Promise<void> {
    this.showAddNewMessageTemplateDialog = false
     if(this.newTemplateName) {
       const payload: CreateNewMessageTemplatePayload = {
         name: this.newTemplateName,
         subject: this.subject,
         text: this.text
     }
     try {
       this.saveInProgress = true
       const response: MessageTemplateListResponse = await this.saveNewTemplate(payload)
       this.saveInProgress = false
       this.selectedItemValue = MessageTemplateList.createFromResponse(response)
       this.fetchTemplate()
       this.snackbar = true
       this.snackbarMessage = this.$t('sendEmailDialog.saved').toString()
       this.snackbarColor = 'success'
    } catch (e) {
       this.snackbar = true
       this.snackbarMessage = this.$t('sendEmailDialog.valueNotSaved').toString()
       this.snackbarColor = 'error'
     }}
  }

  async onDeleteTemplateClick (item: MessageTemplateList): Promise<void>{
    this.showControlDeleteMessageDialog = false
    const selectedItemId: string = item.id
    const payload: string = selectedItemId
    try {
      await this.deleteMessageTemplate(payload)
      this.fetchTemplate()
      this.selectedItemValue = null
      this.text = ''
      this.subject = ''
      this.$refs.form.resetValidation()
      this.snackbar = true
      this.snackbarMessage = this.$t('sendEmailDialog.deleted').toString()
      this.snackbarColor = 'success'
    }catch (e) {
      this.snackbar = true
      this.snackbarMessage = this.$t('sendEmailDialog.deleteDataError').toString()
      this.snackbarColor = 'error'
    }
  }

  async onUpdateTemplateClick (item: MessageTemplateList): Promise<void>{
    const payload: UpdateMessageTemplatePayload = {
      id: item.id,
      name: item.name,
      subject:item.subject,
      text:this.text
    }
    try {
      this.saveInProgress = true
      this.isFetchInProgress = true
      await this.updateMessageTemplate(payload)
      this.saveInProgress = false
      this.fetchTemplate()
      this.isFetchInProgress = false
      this.snackbar = true
      this.snackbarMessage = this.$t('sendEmailDialog.dataSaved').toString()
      this.snackbarColor = 'success'
    }catch (e) {
      this.snackbar = true
      this.snackbarMessage = this.$t('sendEmailDialog.valueNotSaved').toString()
      this.snackbarColor = 'error'
    }
  }

  async fetchTemplate (): Promise<void> {
    try {
      this.isTemplateList = true
      this.templateList = await this.fetchTemplateList()
      this.isTemplateList = false
    } catch (e) {
      this.snackbar = true
      this.snackbarMessage = this.$t('sendEmailDialog.fetchDataError').toString()
      this.snackbarColor = 'error'
    }
  }

  mounted () {
    this.replyToAddress = localStorage.getItem(REPLY_TO_ADDRESS_KEY) || ''

    this.isFormValid = false
    this.fetchTemplate()
    this.currentBoarderList = _.cloneDeep(this.boarderList)
        .sort((a, b) => a.person.familyName.localeCompare(b.person.familyName))
        .map((b: BoarderResponse): BoarderSelectableListItem => {
          return {
            boarder: b,
            isSelected: true
          }
        })

  }
}

</script>

<style lang="stylus" scoped>
.card-body
  overflow auto
</style>